<template>
<div>
<div class="syn-content">
  <mu-row gutter>
    <mu-col width="100" tablet="60" desktop="60">
      <mu-paper :zDepth="1" rounded >
        <div class="card-toolbar color-black" style="background-color: #eeeeee; border: 1px solid #edf1f2;">
          <span class="card-toolbar-title" style="color: rgba(0, 0, 0, 0.87);">
            <a href="#/scan" style="color:black;">Colis / code barre</a>
          </span>
          <span>
            <mu-flat-button v-show="!saveProgress" style="min-width: 44px;"
                @click="printBar()" 
                icon="picture_as_pdf"></mu-flat-button>
            <mu-flat-button icon="cached" style="min-width: 44px;"></mu-flat-button>
          </span>
        </div>
        <mu-list>
          <template v-for="(item, index) in barcode" >
            <mu-divider :key="index" v-if="index"></mu-divider>
            <mu-list-item :key="index"
              :href="'#/declaration/' + item.fk_soc"
              :title="item.cus_name">
              <mu-icon slot="left" value="library_books"></mu-icon>
              <mu-badge 
                :title="item.borddt"
                :content="item.barcode_scan + ' / ' + item.barcode_count" 
                secondary slot="after"></mu-badge>
            </mu-list-item>
          </template>
        </mu-list>
      </mu-paper>
    </mu-col>
    <mu-col width="100" tablet="40" desktop="40">
      <mu-paper :zDepth="1" >
        <div class="card-toolbar color-black" style="background-color: #eeeeee; border: 1px solid #edf1f2;">
          <span class="card-toolbar-title" style="color: rgba(0, 0, 0, 0.87);">
            <a href="#/invoice" style="color:black;">Chauffeurs</a>
          </span>
          <span><mu-flat-button icon="cached" style="min-width: 44px;"></mu-flat-button></span>
        </div>
        <mu-list>
          <mu-list-item v-for="(item, index) in driver" :key="index" :title="item.firstname + ' ' + item.name + ''">
            <mu-badge :content="item.tel1" primary slot="after"></mu-badge>
          </mu-list-item>
        </mu-list>
      </mu-paper>
    </mu-col>
  </mu-row>
</div>
</div>
</template>

<script>
import paper      from 'muse-components/paper'
import icon       from 'muse-components/icon'
import flatButton from 'muse-components/flatButton'
import {col, row} from 'muse-components/grid'
import {list, listItem}  from 'muse-components/list'
import divider    from 'muse-components/divider'
import badge      from 'muse-components/badge'

export default {
  name: 'dashboard',
  data () {
    return {
        saveProgress: false,
        barcode: [],
        driver: [],
    }
  },
  mounted:function (){
    window.axios.post( '/', { _method:'GET', _path:'barcode', limit: 10, order:'DESC', borddt: '' } ) //this.getToday(-1)
    .then( (response) => {
        this.barcode = response.data

    })
    window.axios.post( '/', { _method:'GET', _path:'driver', limit: 12, order:'DESC' } )
    .then( (response) => {
        this.driver = response.data
    })
  },
  methods:{
    getToday(addDay){
        var addDay= addDay || 0
        var today = new Date();
        today.setDate( today.getDate() + addDay )
        var dd    = today.getDate();
        var mm    = today.getMonth()+1; //January is 0!
        var yyyy  = today.getFullYear();
        if(dd<10){ dd='0'+dd; }
        if(mm<10){ mm='0'+mm; }
        return dd+'/'+mm+'/'+yyyy
    },
    printBar(){
      this.saveProgress = true
      window.axios.get( '/', {
          params: { _method:'GET', _path:'report/1/barcode' },
          responseType:"blob"
      })
      .then( (response) => {
          this.saveProgress = false
          this.$download(response.data, "barcode.pdf", "application/pdf")
      })
    }
  },
  components: {
    'mu-paper': paper,
    'mu-icon': icon,
    'mu-list': list,
    'mu-list-item' : listItem,
    'mu-flat-button': flatButton,
    'mu-row': row,
    'mu-col': col,
    'mu-badge': badge,
    'mu-divider': divider
  }
}
</script>



// WEBPACK FOOTER //
// Dashboard.vue?111d7a2f